/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import borders from "assets/theme-dark/base/borders";
import boxShadows from "assets/theme-dark/base/boxShadows";
import colors from "assets/theme-dark/base/colors";

const { borderRadius } = borders;
const { xxl } = boxShadows;
const { background, text } = colors;

const dialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.xl,
      boxShadow: xxl,
      // MUI's default Paper renders white in dark mode unless the theme
      // explicitly overrides it. Also disable the default gradient overlay
      // (backgroundImage) that MUI adds to Paper at elevation > 0 — that
      // gradient lightens the surface and leaves the dialog looking white.
      backgroundColor: background.card,
      color: text.main,
      backgroundImage: "none",
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
